var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0485 15.5239C15.5536 16.0188 14.8606 16.3299 14.111 16.3299C13.3757 16.3299 12.6827 16.0471 12.1665 15.5309C11.6503 15.0147 11.3604 14.3147 11.3675 13.5864L11.3675 11.5924C11.3675 11.1822 11.7069 10.8428 12.117 10.8428C12.5271 10.8428 12.8665 11.1822 12.8665 11.5924L12.8666 13.5864C12.8666 13.9258 12.9938 14.2369 13.2272 14.4703C13.4605 14.7036 13.7787 14.838 14.111 14.8309C14.804 14.8309 15.3626 14.2723 15.3626 13.5793L15.3626 10.4398C15.3626 8.64371 13.906 7.18708 12.1099 7.18709C10.3139 7.18709 8.85727 8.64371 8.85727 10.4398L8.85723 13.8622C8.85723 14.5834 9.13303 15.2552 9.63507 15.7572C10.1371 16.2593 10.8159 16.5421 11.5301 16.535C11.9402 16.535 12.2796 16.8744 12.2796 17.2846C12.2796 17.6947 11.9402 18.0341 11.5301 18.0341C10.4129 18.0341 9.36637 17.5957 8.57441 16.8037C7.78245 16.0118 7.34403 14.9653 7.34403 13.848L7.34405 10.4256C7.34405 7.80931 9.47949 5.67387 12.0958 5.67387C14.7121 5.67387 16.8475 7.80933 16.8475 10.4256L16.8476 13.5652C16.8546 14.3359 16.5506 15.0218 16.0485 15.5239Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachCircle);
export default __webpack_public_path__ + "static/media/attach-circle.5617cf89b0f3b2d51b6133ab36ae7e5c.svg";
export { ForwardRef as ReactComponent };